import React, { useCallback } from 'react'
import { Select as GSelect } from 'grommet'
const Select = props => {
  const {
    dropHeight = 'auto', ariaLabel, children, ...rest
  } = props
  const updateAriaLabel = useCallback(ref => {
    if (!ref) return
    ref.setAttribute('aria-label', ariaLabel)
  }, [ariaLabel])
  return (
    <GSelect ref={updateAriaLabel} {...rest} dropHeight={dropHeight}>
      {children}
    </GSelect>
  )
}
export default Select